

















import { Vue, Component } from "../vue-ext";
import { Message, HousingCompany } from "../models";

@Component
export default class MessageView extends Vue {
    private message: Message | null = null;
    private housingCompany: HousingCompany | null = null;
    private messageId: number | null = null;

    private async created() {
        this.root.setTitle(this.$t("menu.messages") as string);
        this.root.setIconClass("icon-tiedotteet");
        this.housingCompany = this.root.getCurrentHousingCompany() as HousingCompany;

        const id = parseInt(this.$route.params.id, 10);
        this.messageId = id;

        if (this.messageId) {
            this.message = this.root.getMessage(this.messageId) as Message; 
            this.message.readOn = new Date();

            setTimeout(this.getUpdatedMessage, 1);
        }
    }

    private async getUpdatedMessage() {
        if (this.messageId) {
            this.message = await this.root.service.message.GetMessage(this.messageId);
        }
    }
}
